function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useState } from 'react';
import './horizontalGraph.scss';
import CsMadrid from './../../assets/persons/madrid/Begoña_Villacís_Cs.png';
import IUMadrid from './../../assets/persons/madrid/carlos-sanchez-mato_IU.png';
import PPMadrid from './../../assets/persons/madrid/Jose-Luis-Martinez-Almeida_PP.png';
import MMMadrid from './../../assets/persons/madrid/Manuela_Carmena_MAS_MADRID.png';
import VOXMadrid from './../../assets/persons/madrid/ortegasmith_VOX.png';
import PSOEMadrid from './../../assets/persons/madrid/pepuhernandez_PSOE.png';
import CUPBcn from './../../assets/persons/barcelona/Anna-Saliente_CUP.png';
import BComuBcn from './../../assets/persons/barcelona/Colau_B-comú.png';
import ERCBcn from './../../assets/persons/barcelona/Ernest-Maragall_ERC.png';
import PSCBcn from './../../assets/persons/barcelona/jaume-collboni_PSC.png';
import JxCatBcn from './../../assets/persons/barcelona/Joaquin-Forn_JxCAT.png';
import CsBcn from './../../assets/persons/barcelona/Manuel-Valls_CS.png';
import PPBcn from './../../assets/persons/barcelona/José-Bou-Vila_PP.png';
const partiesPhotos = {
  '28079': {
    //Madrid
    '1003592': CsMadrid,
    //Cs
    '1003521': PPMadrid,
    //PP
    '1021626': IUMadrid,
    //M en pie
    '1022563': MMMadrid,
    //Mas madrid
    '1027165': VOXMadrid,
    //Vox
    '1002046': PSOEMadrid //PSOE

  },
  '08019': {
    //BCN
    '1003133': CUPBcn,
    //CUP
    '1003464': BComuBcn,
    //Bcomu
    '1030943': ERCBcn,
    //ERC
    '1002046': PSCBcn,
    //PSC
    '1003149': JxCatBcn,
    //JxCat
    '1003126': CsBcn,
    //Cs
    '1003521': PPBcn //PP

  }
};

const HorizontalGraph = ({
  data,
  leyend = true,
  dataKey = 'seats',
  total = 1,
  place = null,
  showFaces = false,
  showLabel,
  label,
  labelAbrv
}) => {
  const _useState = useState({
    x: null,
    y: null
  }),
        _useState2 = _slicedToArray(_useState, 2),
        mousePos = _useState2[0],
        setMousePos = _useState2[1];

  const _useState3 = useState(),
        _useState4 = _slicedToArray(_useState3, 2),
        selectedParty = _useState4[0],
        setSelectedParty = _useState4[1];

  const mouseEnter = (e, party) => {
    setMousePos({
      x: e.clientX,
      y: e.clientY
    });
    setSelectedParty(party);
  };

  const mouseLeave = () => {
    setMousePos({
      x: null,
      y: null
    });
  };

  if (!data) {
    return React.createElement("div", null, "Loading");
  }

  return React.createElement(Fragment, null, leyend && React.createElement("div", {
    className: "horizontalGraphLeyend"
  }, React.createElement("ul", {
    className: "leyendParties"
  }, data.map(party => {
    if (party[dataKey] > 0) {
      return React.createElement("li", {
        className: "leyendParty",
        key: "".concat(party.partyAcronym, "-").concat(party.id),
        style: {
          width: party[dataKey] / total * 100 + '%'
        }
      }, showFaces && partiesPhotos[place][party.id] && React.createElement("span", {
        className: "partyCircle",
        style: {
          backgroundColor: party.partyColor
        }
      }, React.createElement("img", {
        src: partiesPhotos[place][party.id],
        alt: party.partyAcronym
      })), React.createElement("span", {
        className: "leyendParty_txt"
      }, party.partyAcronym));
    }

    return React.createElement("li", null);
  }))), React.createElement("div", {
    className: "horizontalGraph"
  }, React.createElement("div", {
    className: "horizontalGraph_container"
  }, React.createElement("div", {
    className: "horizontalGraph_bars"
  }, React.createElement("div", {
    className: "horizontalGraph_bar"
  }, data.map(party => {
    return React.createElement("div", {
      className: "horizontalGraph_bar_content",
      key: party.partyAcronym,
      style: {
        backgroundColor: party.partyColor,
        width: party[dataKey] / total * 100 + '%'
      },
      onMouseMove: e => mouseEnter(e, party),
      onMouseLeave: () => mouseLeave()
    }, React.createElement("span", {
      className: "horizontalGraph_bar_txt"
    }, party[dataKey]));
  })), showLabel && React.createElement("div", {
    className: "horizontalGraph_line"
  }, React.createElement("div", {
    className: "horizontalGraph_line_txt"
  }, "Mayor\xEDa absoluta", React.createElement("span", {
    className: "horizontalGraph_line_number"
  }, Math.trunc(total / 2 + 1)))))), mousePos.x && React.createElement("div", {
    className: "horizontalGraph_tooltip",
    style: {
      position: 'fixed',
      left: mousePos.x < window.innerWidth / 2 ? mousePos.x + 15 : mousePos.x - 170,
      top: mousePos.y - 5,
      borderLeft: '10px solid ' + selectedParty.partyColor
    }
  }, React.createElement("h3", {
    className: "partyName"
  }, selectedParty.partyAcronym), React.createElement("p", {
    className: "partySeats"
  }, selectedParty[dataKey], " ", label || 'escaños'), React.createElement("p", {
    className: "partyVotes"
  }, Number(selectedParty.votesPercent).toLocaleString('es'), " %", ' '))));
};

export default HorizontalGraph;